<template>
  <section class="welcome-section">
    <h1 class="welcome-title heading-3">
      {{ $i18nPresenter.t('Hey {userName}!', { userName }) }}
    </h1>
    <p class="welcome-message">
      {{ $i18nPresenter.t('Get your audience talking—start with the right slide.') }}
    </p>
  </section>
</template>

<script>
export default {
  name: 'WelcomeSection',
  props: {
    userName: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.welcome-section {
  width: 100%;
  padding-top: 16px;
  color: #282E3E;

  .welcome-title {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 2.5rem;
  }

  .welcome-message {
    font-size: 1rem;
    line-height: 1.75rem;
  }
}
</style>
